<template>
  <Navigator></Navigator>
  <Loader></Loader>
  <router-view />
</template>

<script>
import Navigator from './components/Navigator.vue'
import Loader from './pages/Loader.vue'

export default {
  name: 'App',
  components: { Navigator, Loader },
}
</script>

<style scoped>
@import './utils/scroll.css';

#homeButton
{
  position: fixed;
  margin-top: 0;
}
</style>

<style>
.underLineW,
.underLineB
{
  border: 0;
  transition: border 200ms ease-out;
}
.underLineW
{
  border-bottom: 2px solid #f5f5f5;
}
.underLineW:hover
{
  border-bottom: 2px solid transparent;
}
.underLineB
{
  border-bottom: 2px solid #111111;
}
.underLineB:hover
{
  border-bottom: 2px solid transparent;
}
</style>